// extracted by mini-css-extract-plugin
export default {"header":"Header_header__fKZP2","closeButton":"Header_closeButton__nco2E"};